import { DynamicItem, TenantBasicDetails } from 'store/tenant/types';
import { StoreDispatch } from '../store/configureStore';
import { createTenant, getTenantDetailsThunk, submitTenantApplicationThunk, submitTenantPetInfoDataThunk } from '../store/tenant/thunks';

export const stageOneSubmitHandler = (formData: any) => async (dispatch: StoreDispatch) => {
    try {
        const result = await dispatch(createTenant(formData));
        return result;
    } catch (error) {
        // Stage One Submit Error
    }
};

export const getTenantDetails = (tenantId: string, applicationId: string) => async (dispatch: StoreDispatch) => {
    try {      
      const tenantDetails  = await dispatch(getTenantDetailsThunk({ tenantId, applicationId }));
      return tenantDetails;
    } catch (error) {
      // Error fetching tenant details
      return null;
    }
    
  }

export const tenantSubmitApplication = (tenantData: any, applicationId: string) => async (dispatch: StoreDispatch) => {
    try {
        const result = await dispatch(submitTenantApplicationThunk({ tenantData, applicationId }));
        return result;
    } catch (error) {
        // Submit Tenant Application Error
    }
};

export const saveTenantPetData = (tenantData: any, applicationId: string) => async (dispatch: StoreDispatch) => {
    try {
        const result = await dispatch(submitTenantPetInfoDataThunk({ tenantData, applicationId }));
        return result;
    } catch (error) {
        // Submit Tenant pet data Error
    }
};

export const formatTenantList = (arr: Array<TenantBasicDetails>) => {
  return arr
    .map(
      t =>
        `${t?.first_name || ""} ${t.last_name || ""} (${t.email})`
    )
    .join('<br />');
}

export const isAgent = () => {
    return window.location.href.includes('/agent/');
}

export const isTenant = () => {
    return window.location.href.includes('/tenant/');
}

export const isLandlord = () => {
    return window.location.href.includes('/landlord/');
}

export function getAllErrorMessages(apiResponse: any): string[] {
  if (!apiResponse || !apiResponse.errors) return [];
  // Flatten all error arrays into a single array of messages
  return Object.values(apiResponse.errors).flat() as string[];
}

export const getRoleType = () => {
  if (isAgent()) return 'agent';
  if (isTenant()) return 'tenant';
  if (isLandlord()) return 'landlord';
  return "";
}

/**
 * Updates a specific item in tenantItems by uid.
 * @param items Array of DynamicItem
 * @param uid Unique identifier of the item to update
 * @param updatedFields Fields to update in the item
 * @returns Updated array of DynamicItem
 */
export function updateTenantItemByUid(
  items: DynamicItem[],
  uid: number,
  updatedFields: Partial<DynamicItem>
): DynamicItem[] {
  // Return a new array with the updated item, preserving pet_id if exists
  return items.map(item => {
    if (item.uid === uid) {
      return { ...item, ...updatedFields };
    }
    // Keep existing pet_id if present
    return item;
  });
}